module.exports = __webpack_public_path__ + "static/img/indexbg11.08414d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/indexbg11.jpg
// module id = kEws
// module chunks = 1